import * as React from "react";
function SvgFold(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <g clipPath="url(#fold_svg__clip0_8_1227)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.998 3.291a1 1 0 01.295.709v13a1 1 0 01-1 1h-3v3a1 1 0 01-1.351.936l-8.649-3.243V3.059L18.288 3a1 1 0 01.71.291zM15.293 16h2V5.005l-5.55.025 2.901 1.088a1 1 0 01.649.936V16zm-8-10.503v11.81l6 2.25V7.747l-6-2.25z"
                    fill="currentcolor"
                />
            </g>
            <defs>
                <clipPath id="fold_svg__clip0_8_1227">
                    <path
                        fill="#fff"
                        transform="translate(.293)"
                        d="M0 0h24v24H0z"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgFold);
export default ForwardRef;
